<template name="inviteListExternal">
  <div class="invite-list" v-infinite-scroll="this.getMoreList" infinite-scroll-disabled="isLoading" infinite-scroll-distance="100" infinite-scroll-immediate-check="true">
    <div class="block container">
      <div class="block-header">
        <div class="row">
          <div class="col-12 col-md-5">
            <h2 class="block-title">{{$t('invitationList')}}</h2>
            <i class="iconfont icon-close" @click="closeList"></i>
          </div>
          <div class="col-12 col-md-7">
            <div class="row">
              <div class="col-10">
                <i class="iconfont icon-search"></i>
                <input type="" name="" @keyup.enter="getInviteList()" class="form-control" :placeholder="$t('searchCondition')" v-model="keywords">
                <i class="iconfont icon-close clear-input" @click="clearInput" v-show="keywords.trim().length"></i>
              </div>
              <div class="search-btn col-2">
                <button class="btn" :class="{ searchable: keywords.trim() }" :disabled="!keywords.trim()" @click="getInviteList()">{{ $t('Search') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block-content">
        <div class="row">
          <div class="col-12 col-md-3">
            <div class="tab row">
              <div class="tab-col col-md-12" 
                :class="item.active"
                v-for="(item, index) in this.tabs" :data-index="index" @click="activeTabs(index)">
                {{item.name}}
              </div>
            </div>
          </div>
          <div class="col-12 col-md-9">
            <div class="data-list" v-infinite-scroll="this.getMoreList" infinite-scroll-disabled="isLoading" infinite-scroll-distance="100" infinite-scroll-immediate-check="true">
              <div class="no-list" v-if="!this.visitList.length" v-show="!this.isLoading">
                <div class="inner" v-if="searched">
                  <img src="../assets/images/search-no-result@2x.png" class="icon">
                  <h5>{{ $t('NoResult') }}</h5>
                </div>
                <div class="inner" v-else>
                  <img src="../assets/images/no-result@2x.png" class="icon">
                  <h5>{{ $t('NoInvitationForThisList') }}</h5>
                  <p>{{ $t('NoInvitationInfo') }} </p>
                </div>
              </div>
              <ul>
                <li v-for="(item, index) in this.visitList" @click="closeVisitList">
                  <router-link :to="'/external/detailIndex/' + item.ticketId +'/0'">
                    <div class="top row">
                      <div class="col-9">
                        <div class="top">
                          <span class="radius-list" ></span>
                          <span class="title bold">
                            {{item.title}}
                          </span>
                        </div>
                      </div>
                      <div class="col-3 col-status">
                        <span class="status-list bold">
                          {{item.ticketStatusDesc}}
                        </span>
                      </div>
                    </div>
                    <div class="bottom row">
                      <div class="col renyuanguanli">
                        <i class="iconfont icon-renyuanguanli"></i>
                        <span>{{item.visitorNumber}}{{ $t('People') }}</span>
                      </div>
                      <div class="col time">
                        <i class="iconfont icon-clock"></i>
                        <span>{{item.startTime}} - {{item.endTime}}</span>
                      </div>
                      <div class="col bottle-order-list" v-if="item.bottleOrderNumberList.length">
                        <i class="icon icon-factory"></i>
                        <span v-for="(order, j) in item.bottleOrderNumberList">{{order.bottleName}}<span v-show="order.orderNumber" class="order-number">/{{order.orderNumber}}</span></span>
                      </div>
                    </div>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
   <loading :active.sync="isLoading" :color="'#e42029'"></loading>
  </div>
</template>

<script type="text/javascript">;
import Vue from "vue";
import { getExternalInviteList } from '@/utils/api';
import { checkNested } from '@/utils/utils';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import infiniteScroll from 'vue-infinite-scroll';

Vue.use(infiniteScroll);
const MobileDetect = require('mobile-detect');

const md = new MobileDetect(window.navigator.userAgent);
const isPhone = !!md.phone();
const winHeight = window.innerHeight;
export default {
  name: 'inviteListExternal',
  props: [],
  data() {
    return {
      keywords: '',
      tabs: [],
      visitList: [],
      tabsInit: [
        {
          active: 'active',
          name: this.$t('before'),
        },
        {
          active: '',
          name: this.$t('Ongoing'),
        },
        {
          active: '',
          name: this.$t('past'),
        },
      ],
      pageIndex: 1,
      pageCount: 10,
      totalPages: 0,
      isLoading: false,
      isAllLoaded: false,
      tabStatus: 1,
      searched: false,
      searchbtn: false,
    };
  },
  components: {
    Loading,
  },
  watch: {
  },
  methods: {
    clearInput() {
      this.keywords = '';
    },
    activeTabs(currentindex) {
      var newTabs = this.tabs;
      const index = currentindex;
      for (let i = 0; i < newTabs.length; i += 1) {
        if (i == index) {
          newTabs[i].active = 'active';
        } else {
          newTabs[i].active = '';
        }
      }
      this.tabStatus = index + 1;
      this.getInviteList();
    },
    closeList: function closeList() {
      this.$emit('changeVisitListStatus', false);
    },
    bindData(res, isMore) {
      if (checkNested(res, 'data', 'content', 'model', 'entities')) {
        if (isMore) {
          this.visitList = [...this.visitList, ...res.data.content.model.entities];
        } else {
          this.visitList = res.data.content.model.entities;
        }
        this.totalPages = res.data.content.model.totalPages;
        this.isAllLoaded = this.pageIndex === this.totalPages;

        this.pageIndex = this.pageIndex < this.totalPages
        ? this.pageIndex + 1 : this.totalPages;
      }
    },
    getInviteList(isMore) {
      this.isLoading = true;
      this.searched = this.keywords === '' ? false : true;
      if (!isMore) {
        this.pageIndex = 1;
      }
      getExternalInviteList(this.pageIndex, this.pageCount, this.keywords, this.tabStatus, 0).then((res) => {
        this.isLoading = false;
        this.bindData(res, isMore);
      });
    },
    getMoreList() {
      if (!this.isAllLoaded) {
        this.getInviteList(true);
      }
    },
    closeVisitList() {
      this.$emit('changeVisitListStatus',false);
    },
    copyArr: function(p, c){
      var c = c || {};
      for (var i in p) {
        if (typeof p[i] === "object") {
          c[i] = (p[i].constructor === Array) ? [] : {};
          this.copyArr(p[i], c[i]);
        } else {
          c[i] = p[i]
        }
      }    
      return c;
    },
  },
  created: function () {
    var tabs = [];
    this.copyArr(this.tabsInit, tabs);
    this.tabs = tabs;
    this.getInviteList();
  },
};
</script>
<style lang="scss">
.show-invite-list {
  color: #4a4a4a;
  height: 100vh;
  overflow: hidden;
  .detail-header {
    box-shadow: 0 0 15px rgba(100, 100, 100, 0.15);
    background: #fff;
    width: 100%;
    z-index: 9999;
    position: fixed;
  }
  main {
    padding: 20px 0;
  }
  .detail-header .row .header-right .two-link .invite {
    position: relative;
    &:after {
      content: '';
      width: 100%;
      height: 3px;
      position: absolute;
      bottom: 0;
      left: 0;
      background: #e42029;
    }
    span,
    i {
      color: #e42029;
    }
  }
}
#app {
  overflow-x: hidden;
}
</style>
<style scoped lang="scss">
@import "../scss/variables.scss";
.invite-list {
  position: fixed;
  top: 56px;
  bottom: 54px;
  left: 0;
  right: 0;
  background: #fff;
  padding: 15px 0;
  z-index: 6666;
  overflow-x: hidden;
  overflow-y: auto;
  .block {
    height: 100%;
  }
  .container {
    padding-left: 15px;
    padding-right: 15px;
  }
  .block-header {
    padding: 12px 0;
    border-bottom: 1px solid #f0f1f2;
    & > .row {
      justify-content: space-between;
    }
    .block-title {
      font-size: 18px;
      font-weight: bold;
      & + .icon-close {
        position: absolute;
        line-height: 21px;
        font-size: 18px;
        top: 0;
        right: 15px;
        display: none;
        cursor: pointer;
        @include respond-to('sm-max') {
          display: block;
        }
        @include respond-to('ml') {
          display: block;
        }
      }
    }
    .col-md-7 {
      max-width: 340px;
    }
    .col-12 {
      position: relative;
    }
    .icon-search {
      position: absolute;
      top: 0;
      left: 25px;
      line-height: 36px;
      color: #999;
      font-size: 18px;
    }
    .inner {
      width: 90%;
      padding: 10px 0;
      margin: 0 auto;
    }
    input.form-control::-ms-clear {
       display: none;
    }
    .form-control {
      height: 36px;
      border-radius: 18px;
      border: 0;
      font-size: 14px;
      padding: 0 20px 0 36px;
      background: #f1f1f1;
    }
    .clear-input {
      position: absolute;
      right: 25px;
      top: 10px;
      width: 18px;
      height: 18px;
      background-color: #9b9b9b;
      border-radius: 100%;
      color: #fff;
      line-height: 18px;
      text-align: center;
      cursor: pointer;
    }
    .search-btn {
      font-size: 14px;
      padding-left: 0;
      text-align: right;
      .btn {
        display: block;
        width: 100%;
        border: 0;
        font-size: 14px;
        color: #929292;
        padding: 0.375rem 0;
        &.searchable {
          color: #e42029;
        }
      }
    }
    @include respond-to('sm-max') {
      border-bottom: none;
      .block-title {
        margin-bottom: 15px;
      }
      .col-md-7 {
        max-width: 100%;
      }
    }
    @include respond-to('ml') {
      border-bottom: none;
      .block-title {
        margin-bottom: 15px;
      }
      .col-md-5,
      .col-md-7 {
        flex: 0 0 100%;
        max-width: 100%;
      }
    }
  }
  .block-content {
    margin-top: 20px;
    .col-md-9 {
      padding: 0;
    }
    @include respond-to('sm-max') {
      margin-top: 0;
    }
    @include respond-to('ml') {
      margin-top: 0;
      .col-4 {
        flex: 0 0 33.33333%;
        max-width: 33.33333%;
      }
      .col-12 {
        flex: 0 0 100%;
        max-width: 100%;
      }
    }
  }
}
.tab {
  margin: 0;
  padding: 10px 0 0;
  .tab-col {
    background: #fff;
    box-shadow: 0 5px 20px rgba(100, 100, 100, 0.15);
    line-height: 48px;
    font-size: 14px;
    color: #929292;
    border-radius: 4px;
    overflow: hidden;
    border-left: 3px solid #cdcdcd;
    margin-bottom: 15px;
    cursor: pointer;
    &.active {
      color: #e42029;
      font-weight: bold;
      border-color: #e42029;
    }
  }
  @include respond-to('sm-max') {
    padding-top: 0;
    justify-content: space-between;
    border-bottom: 1px solid #f0f1f2;
    margin-bottom: 15px;
    .tab-col {
      padding: 0 4px;
      line-height: 36px;
      border-radius: 0;
      box-shadow: none;
      border-left: 0;
      flex: inherit;
      max-width: inherit;
      width: auto;
      margin-bottom: 0;
      color: #394a54;
      font-weight: bold;
      &.active {
        border-bottom: 3px solid #e42029;
      }
    }
  }
  @include respond-to('ml') {
    padding-top: 0;
    justify-content: space-between;
    border-bottom: 1px solid #f0f1f2;
    margin-bottom: 15px;
    .tab-col {
      padding: 0 4px;
      line-height: 36px;
      border-radius: 0;
      box-shadow: none;
      border-left: 0;
      flex: inherit;
      max-width: inherit;
      width: auto;
      margin-bottom: 0;
      color: #394a54;
      font-weight: bold;
      &.active {
        border-bottom: 3px solid #e42029;
      }
    }
  }
}
.data-list {
  overflow-x: hidden;
  overflow-y: auto;
  padding: 10px 15px 15px;
  ul {
    margin: 0 auto;
    padding: 0;
    li {
      list-style: none;
      margin-bottom: 15px;
      border-radius: 4px;
      background-color: #fff;
      box-shadow: 0 5px 20px rgba(100, 100, 100, 0.15);
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  a {
    display: block;
    padding: 15px 12px;
    text-decoration: none;
    &:hover {
      text-decoration: none;
    }
  }
  .top {
    align-items: center;
    .radius-list {
      display: inline-block;
      margin-right: 7px;
      vertical-align: middle;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: #ff2137;
      border: 3px solid #ffe2ef;
    }
    .title {
      font-size: 14px;
      color: #212529;
      font-weight: bold;
    }
    .col-status {
      text-align: right;
      color: #e42029;
      font-size: 12px;
      word-break: break-word;
      font-weight: bold;
    }
  }
  .bottom {
    padding-top: 5px;
    margin: 0;
    .col {
      padding: 0 8px 0 0;
      width: auto;
      flex-basis: auto;
      flex-grow: inherit;
    }
    i {
      font-size: 14px;
      color: #e42029;
    }
    span {
      font-size: 12px;
      color: #929292;
      padding-left: 5px;
    }
    .bottle-order-list {
      .icon-factory {
	      display: inline-block;
	      width: 14px;
	      height: 14px;

	      &:before {
	        content: '';
	        width: 14px;
	        height: 14px;
	        display: inline-block;
	        background: url(../assets/images/external/bottle-factory@2x.png);
	        background-size: 100% 100%;
	        position: absolute;
	        top: 6.5px;
	      }
	    }

	    .order-number{
	      padding-left: 0;
	    }
    }
  }
  @include respond-to('sm-max') {
    height: calc(100vh - 276px);
  }
  @include respond-to('ml') {
    height: calc(100vh - 276px);
  }
}
.no-list {
  padding-top: 60px;
  text-align: center;
  .icon {
    width: 86px;
    height: 86px;
    margin: 0 auto 15px;
  }
  h5,
  p {
    font-size: 13px;
  }
  h5 {
    font-weight: bold;
  }
  .btn-back {
    width: 125px;
    height: 42px;
    font-size: 15px;
    line-height: 28px;
    color: #fff !important;
    margin-top: 5px;
    padding: 6px 12px !important;
    display: inline-block !important;
    background-image: linear-gradient(69deg, #f36443, #e42029) !important;
    &:focus,
    &:hover {
      box-shadow: none;
    }
  }
}
</style>
